import { useState, type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Box, Chip, Icon, LoadingButton, Tooltip } from '@myn/mui';

import { useRefetchBuyingPlanInfo } from '../../../hooks/useGetBuyingPlanData.js';
import { useSetIsArchivedVersion } from '../../../hooks/useIsArchivedVersion.js';

type Props = {
  version: string;
};

const ArchivedVersion: FC<Props> = ({ version }) => {
  const { t } = useTranslation('@myn/planning');

  const [isLoading, setIsLoading] = useState(false);
  const refetchBuyingPlanInfo = useRefetchBuyingPlanInfo();
  const setIsArchivedVersion = useSetIsArchivedVersion();

  const getLastVersion = async () => {
    try {
      setIsLoading(true);
      await refetchBuyingPlanInfo();
      setIsArchivedVersion(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={t('This Buying Plan version is archived')}>
        <Box className="max-w-[300px]">
          <Chip
            variant="filled"
            size="medium"
            color="silver"
            label={version}
            disabled
          />
        </Box>
      </Tooltip>
      <LoadingButton
        color="primary"
        variant="text"
        size="small"
        startIcon={<Icon component="RecentlyViewed" />}
        onClick={getLastVersion}
        loading={isLoading}
      >
        {t('Open active version')}
      </LoadingButton>
    </Box>
  );
};

export default ArchivedVersion;
